import React, { Component } from 'react'
import _ from 'lodash'

export default class Carousel extends Component {

  constructor(props) {
    super(props)
    const banners = this.getBanners()
    this.state = {
      banners: banners,
      currentIndex: 0,
      currentBanner: banners[0]
    }
  }

  componentDidMount() {
    this.timerID = setInterval(
      () => this.changeBanner(),
      3000
    )
  }

  componentWillUnmount() {
    clearInterval(this.timerID)
  }

  changeBanner() {
    const {
      banners,
      currentIndex } = this.state
    const lastIndex = banners.length - 1
    const nextIndex = currentIndex === lastIndex ?
      0 : currentIndex + 1
    const nextBanner = banners[nextIndex]
    this.setState({
      currentIndex: nextIndex,
      currentBanner: nextBanner
    })
  }

  getBanners() {
    let bannerAds = []
    this.props.sponsors.forEach((sponsor) => {
      if(!sponsor.is_hidden){
        bannerAds = bannerAds.concat(sponsor.banner_ads)
      }
    })
    bannerAds = _.shuffle(bannerAds)
    return bannerAds
  }

  render() {
    const { currentBanner } = this.state
    const showCarousel = this.state.banners.length ? '' : 'hide'
    if (!currentBanner) { return <div></div> }
    const isLocal = currentBanner.link_url.indexOf('#/event_sponsor') > -1
    const href = isLocal ?
      '/sponsor' + _.last(currentBanner.link_url.split('#/event_sponsor')) :
      currentBanner.link_url
    const target = isLocal ? '' : '_blank'

    return (
      <div style={{ textAlign: 'center'}} className={'carousel ' + showCarousel}>
        <a target={ target }
          href={ href }>
          <img
            style={{ width: '100%' }}
            src={ currentBanner.graphic_link }
            alt="" />
        </a>
      </div>
    )
  }
}
